module.exports = __webpack_public_path__ + "static/img/frack4.a82194de.png";